import "./sustainability.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faRecycle,
  faSeedling,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";

export default function Sustainability() {
  return (
    <main className="sustainPage">
      <div className="sustainContainer">
        <h1>  <FontAwesomeIcon icon={faLeaf} className="sustainIconLarge" /> Sustainability Promise</h1>

        <div className="sustainIntro">
          <p>
            At Tote Therapy, awareness extends beyond the mind — it includes the environment.
          </p>
        </div>

        <div className="sustainCard">
          <div className="sustainHeader">
            <FontAwesomeIcon icon={faRecycle} className="sustainIcon" />
            <h2>Reusable & Responsible</h2>
          </div>
          <p>
            We design our totes using durable, reusable materials to reduce reliance on single-use plastic bags.
          </p>
        </div>

        <div className="sustainCard">
          <div className="sustainHeader">
            <FontAwesomeIcon icon={faSeedling} className="sustainIcon" />
            <h2>Mindful Design</h2>
          </div>
          <p>
            Our goal is simple: create products that are intentional, long-lasting,
            and aligned with mindful living.
          </p>
        </div>

        <div className="sustainCard highlight">
          <div className="sustainHeader">
            <FontAwesomeIcon icon={faHeart} className="sustainIcon" />
            <h2>Our Belief</h2>
          </div>
          <p>
            Small choices create meaningful impact.
          </p>
        </div>
      </div>
    </main>
  );
}